import { TFunction } from 'i18next'
import { ReactNode } from 'react'
import {
  Briefcase,
  CorporateBuildings,
  Menu,
  Pantheon,
  Trending
} from '@pay-com/icons'
import { IFormConfig } from 'types'
import {
  getBusinessActivityConfig,
  getGeneralInformationConfig,
  getBankingInformationConfig,
  getBeneficialOwnerConfig,
  getIndividualsConfig
} from './UsRegionStepsConfigs'

export type OnboardingStep = {
  id: string
  title: string
  description: string
  shortDescription: string
  headerAdditionalContent?: ReactNode
  submitAdditionalContent?: ReactNode
  stepIcon: ReactNode
  formConfig: IFormConfig<any>
}

export const getUsSteps = (t: TFunction): OnboardingStep[] => [
  {
    id: 'general-information',
    title: t('generalInformation.title'),
    description: t('generalInformation.description'),
    shortDescription: t('generalInformation.shortDescription'),
    stepIcon: <Menu style={{ height: 20 }} fill="black" />,
    formConfig: getGeneralInformationConfig(t)
  },
  {
    id: 'business-activity',
    title: t('businessActivity.title'),
    description: t('businessActivity.description'),
    shortDescription: t('businessActivity.shortDescription'),
    stepIcon: <Trending style={{ height: 20 }} fill="black" />,
    formConfig: getBusinessActivityConfig(t)
  },
  {
    id: 'banking-information',
    title: t('bankingInformation.title'),
    description: t('bankingInformation.description'),
    shortDescription: t('bankingInformation.shortDescription'),
    stepIcon: <Pantheon style={{ height: 20 }} fill="black" />,
    formConfig: getBankingInformationConfig(t)
  },
  {
    id: 'beneficial-owner',
    title: t('beneficialOwner.title'),
    description: t('beneficialOwner.description'),
    shortDescription: t('beneficialOwner.shortDescription'),
    stepIcon: <CorporateBuildings style={{ height: 20 }} fill="black" />,
    formConfig: getBeneficialOwnerConfig(t)
  },
  {
    id: 'individuals',
    title: t('individuals.title'),
    description: t('individuals.description'),
    shortDescription: t('individuals.shortDescription'),
    stepIcon: <Briefcase style={{ height: 20 }} fill="black" />,
    formConfig: getIndividualsConfig(t),
    submitAdditionalContent: (
      <>
        <div className="border-t border-gray-200" />
        <p className="text-sm text-gray-600">
          {t('onboarding.submitConsent.beforeTerms')}
          <a
            href="https://pay.com/legal/us-cross-river-bank-service-agreement-terms"
            target="_blank"
            rel="noreferrer"
            className="text-bluePrimary-800 underline"
          >
            {t('onboarding.submitConsent.termsLabel')}
          </a>
          {t('onboarding.submitConsent.beforePayCom')}
          <a
            href="https://pay.com"
            target="_blank"
            rel="noreferrer"
            className="text-bluePrimary-800 underline"
          >
            {t('onboarding.submitConsent.payComLabel')}
          </a>
          {t('onboarding.submitConsent.afterPayCom')}
        </p>
      </>
    )
  }
]
